import dotenv from 'dotenv';
import flat from 'flat';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';

import { countryByLocale, VALID_LOCALES } from './locale';

global.envVars = {};

function buildLocaleEnv(locale) {
  if (typeof __CLIENT_ENV__ === 'undefined') {
    const localeEnv = cloneDeep(process.env);

    let countryCode = 'US';
    if (countryByLocale) {
      countryCode = countryByLocale(locale);
    }

    localeEnv.CURRENT_LOCALE = locale;

    switch (countryCode) {
      case 'CA':
        localeEnv.GOOGLE_TAG_MANAGER_KEY = localeEnv.GOOGLE_TAG_MANAGER_KEY_CA;
        localeEnv.COOKIE_DOMAIN = localeEnv.COOKIE_DOMAIN_CA;
        break;
      default:
        break;
    }
    return localeEnv;
  }

  return {};
}

function initializeLocaleEnvs() {
  const locales = flat(VALID_LOCALES);
  Object.keys(locales).forEach((k) => { global.envVars[locales[k]] = buildLocaleEnv(locales[k]); });
}

export default function env({ locale = 'en-us' } = { locale: 'en-us' }) {
  if (typeof __CLIENT_ENV__ === 'undefined') {
    // User REDIS_PORT as a shortcut to see if the env file has been loaded
    if (!process.env.REDIS_HOST || !get(global.envVars, [locale, 'REDIS_HOST'], null)) {
      dotenv.config({ path: '/var/domains/api.parkwhiz.com/www/.env' });
      initializeLocaleEnvs();
    }
    return get(global.envVars, locale, {});
  }
  return window.__CLIENT_ENV__;
}

export const isProduction = () => (
  env().IS_PRODUCTION === true || env().IS_PRODUCTION === 'true'
);

export const isAssetIntegrityEnabled = () => (
  env().ENABLE_ASSET_INTEGRITY === true || env().ENABLE_ASSET_INTEGRITY === 'true'
);

// We set INVALIDATE_CACHED_ASSETS to false for local dev.
export const invalidateCachedAssets = () => (
  env().INVALIDATE_CACHED_ASSETS === true || env().INVALIDATE_CACHED_ASSETS === 'true'
);

export const clientEnv = ({ locale = 'en-us' } = { locale: 'en-us' }) => {
  const {
    GOOGLE_API_BROWSER_KEY,
    MIXPANEL_API_KEY,
    NODE_BASE_V3_1_API_URL,
    NODE_BASE_V4_API_URL,
    NODE_BASE_INTERNAL_API_URL,
    NODE_BASE_ENTERPRISE_API_URL,
    NODE_BASE_BP_URL,
    NODE_PW_URL,
    RS_TENANT_ALIAS,
    CDN_HTTPS_HOST,
    CDN_HOST,
    GIT_HASH,
    IS_PRODUCTION,
    ADMIN_HOST,
    GOOGLE_OAUTH_ID,
    GOOGLE_STATIC_MAPS_ID,
    ONELINK_ID,
    CONCUR_APP_CENTER_LINK,
    FORD_AFFILIATE_ID,
    STAPLES_AFFILIATE_ID,
    ENTERPRISE_HOST,
    ENTERPRISE_TS_PADDING,
    RUBYAPP_SECRET,
    UNBOUNCE_ID,
    EXPERIMENTS_BASE_URL,
    INSIGHTS_KEY,
    BASE_V3_1_API_URL,
    ENVIRONMENT,
    PORTAL_URL,
    AIRBRAKE_CLIENT_ID,
    AIRBRAKE_CLIENT_KEY,
    MAPBOX_TOKEN,
    MAPBOX_STYLE,
    INVALIDATE_CACHED_ASSETS,
    ASSET_CDN_HOST,
    TICKETMASTER_PARTNER_ID,
    COOKIE_DOMAIN,
    GOOGLE_TAG_MANAGER_KEY,
    CURRENT_LOCALE,
    ENABLE_UPEXPRESS_BANNER,
    SECURE_COOKIES,
    WIDGET_BASE_URL,
    PW_URL,
  } = env({ locale });

  return {
    COOKIE_DOMAIN,
    GOOGLE_TAG_MANAGER_KEY,
    GOOGLE_API_BROWSER_KEY,
    MIXPANEL_API_KEY,
    NODE_BASE_V3_1_API_URL,
    NODE_BASE_V4_API_URL,
    NODE_BASE_INTERNAL_API_URL,
    NODE_BASE_ENTERPRISE_API_URL,
    NODE_BASE_BP_URL,
    NODE_PW_URL,
    RS_TENANT_ALIAS,
    CDN_HTTPS_HOST,
    CDN_HOST,
    GIT_HASH,
    IS_PRODUCTION,
    ADMIN_HOST,
    GOOGLE_OAUTH_ID,
    GOOGLE_STATIC_MAPS_ID,
    ONELINK_ID,
    CONCUR_APP_CENTER_LINK,
    FORD_AFFILIATE_ID,
    STAPLES_AFFILIATE_ID,
    ENTERPRISE_HOST,
    ENTERPRISE_TS_PADDING,
    RUBYAPP_SECRET,
    UNBOUNCE_ID,
    EXPERIMENTS_BASE_URL,
    INSIGHTS_KEY,
    BASE_V3_1_API_URL,
    ENVIRONMENT,
    PORTAL_URL,
    AIRBRAKE_CLIENT_ID,
    AIRBRAKE_CLIENT_KEY,
    MAPBOX_TOKEN,
    MAPBOX_STYLE,
    INVALIDATE_CACHED_ASSETS,
    ASSET_CDN_HOST,
    TICKETMASTER_PARTNER_ID,
    CURRENT_LOCALE,
    ENABLE_UPEXPRESS_BANNER,
    SECURE_COOKIES,
    WIDGET_BASE_URL,
    PW_URL,
  };
};
